import { Injectable } from '@angular/core';
import { PaymentSystem } from '../models/enums';
import { ProductTypeId } from '../models/enums/product-type.enum';
import { StorageService } from '../services/storage.service';
import { PartnerHostnameProvider } from './partner-hostname.provider';

export interface CartProductInfo {
  productIds: number[];
  partnerPaymentSystemId: PaymentSystem;
  currency: string;
  productTypeId: ProductTypeId;
  widgetContext: WidgetContext;
}

@Injectable({
  providedIn: 'root',
})
export class CartProductInfoProvider {
  static STORAGE_KEY = `cart_product_info-${PartnerHostnameProvider.hostname}`;

  constructor(private storageService: StorageService) {}

  store(info: CartProductInfo): void {
    this.storageService.set(CartProductInfoProvider.STORAGE_KEY, info);
  }

  load(): CartProductInfo | null {
    return this.storageService.get(CartProductInfoProvider.STORAGE_KEY);
  }
}

type WidgetContext = 'main' | 'list';
